const type = {
    TYPE_NAME_STRING : 'String',

    TYPE_NAME_BOOLEAN : 'Boolean',

    TYPE_NAME_INTEGER : 'Integer',

    TYPE_NAME_DOUBLE : 'Double',

    TYPE_NAME_FLOAT : 'Float',

    TYPE_NAME_DATE : 'Date',

    TYPE_NAME_CLASS_CODE : 'CLASS_CODE',

    TYPE_NAME_USER : 'USER',

    TYPE_NAME_IDENTIFIER : 'IDENTIFIER',

    TYPE_NAME_DATA_SET : 'DATA_SET'

};

angular.module('gw-um-j2js')
    .constant('type', type);